import pig_game from "../../assets/projects_images/pig_game.png";
import moviedb from "../../assets/projects_images/moviedb.png";
import covid_tracker from "../../assets/projects_images/covid_tracker.png";
// import COVID from "../../assets/projects_images/COVID.jpg";
import natour_tour from "../../assets/projects_images/natour_tour.png";
import weather from "../../assets/projects_images/weather.png";
import store from "../../assets/projects_images/store.png";
import pincode from "../../assets/projects_images/pincode.png";

const data_projects = [
  {
    name: "Covid -19 Tracker",
    image: covid_tracker,
    deployed_url: "https://covid-19-tracker-20.netlify.app/",
    github_url: "https://github.com/prakash20kumar/covid-19-tracker",
    category: ["react.js"],
  },

  {
    name: "MovieDb",
    image: moviedb,
    deployed_url: "https://movie-db-20.netlify.app/",
    github_url: "https://github.com/prakash20kumar/moviedb",
    category: ["react.js"],
  },

  {
    name: "Natour Tour",
    image: natour_tour,
    deployed_url: "https://prakash20kumar.github.io/nature-tour-project/",
    github_url: "https://github.com/prakash20kumar/nature-tour-project",
    category: ["html_css", "sass"],
  },

  {
    name: "Weather",
    image: weather,
    deployed_url: "http://weather-app-2.atwebpages.com/",
    github_url: "https://github.com/prakash20kumar/weather-app-2",
    category: ["react.js"],
  },

  {
    name: "Store",
    image: store,
    deployed_url: "http://prakash20kumar.atwebpages.com/",
    github_url: "https://github.com/prakash20kumar/MyStore",
    category: ["react.js"],
  },

  {
    name: "Pin Code",
    image: pincode,
    deployed_url: "https://pin-code-search.netlify.app/",
    github_url: "https://github.com/prakash20kumar/Pin-code-search",
    category: ["react.js"],
  },

  {
    name: "Pig Game",
    image: pig_game,
    deployed_url: "https://prakash20kumar.github.io/PigGame/",
    category: ["html_css", "vanilla"],
  },
];

export default data_projects;
